import { render } from "./UserHomeSecond.vue?vue&type=template&id=52a88445&scoped=true"
const script = {}

import "./UserHomeSecond.vue?vue&type=style&index=0&id=52a88445&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a88445"]])

export default __exports__